"use strict";import{IconCornerTriangle300 as e}from"../src/elements/IconCornerTriangle300.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-icon-corner-triangle300",e);
//# sourceMappingURL=sp-icon-corner-triangle300.js.map
